import React from "react";
import Container from "react-bootstrap/Container";
import Alert from "./Alert";
import {Table} from "react-bootstrap";
import Storage from "./Storage";
import Logout, {FormatDate} from "./utils";
import JwtClient from "./JwtClient";

const FILENAME = 'UPS MI Invoice csv'

export default class BillingUPSMI extends React.Component {
    constructor(props) {
        super(props);
        this.invoicesRef = React.createRef();
        this.state = {
            file: null,
            filename: FILENAME,
            fileErr: '',
            formAlert: '',
            listAlert: '',
            invoices: [],
            currentPage: 1,
            pagesTotal: 0,
            formSubmitting: false,
            listLoading: false,
        };
    }

    render() {
        return (
            <div>
                <Container>
                    <h4 ref={this.invoicesRef} className="mt-4">Billing UPS MI</h4>

                    {this.state.formAlert ? <Alert>{this.state.formAlert}</Alert> :
                        <form className="form-row mt-2 mb-3" onSubmit={this.handleSubmit}>
                            <div className="custom-file col-8">
                                <input
                                    type="file"
                                    className={this.state.fileErr ? "custom-file-input is-invalid" : "custom-file-input"}
                                    id="inputFile"
                                    onChange={e => {
                                        const f = e.target.files[0];
                                        this.setState((prevState) => {
                                            return {
                                                file: f,
                                                filename: f && f.name ? f.name : prevState.filename,
                                                fileErr: '',
                                                formAlert: false,
                                            }
                                        })
                                    }}
                                    disabled={this.state.formSubmitting}
                                />
                                <label className="custom-file-label" htmlFor="inputFile">{this.state.filename}</label>
                                {this.state.fileErr ?
                                    <div className="invalid-feedback">{this.state.fileErr}</div>
                                    : null
                                }
                            </div>

                            <button
                                type="submit" className="btn btn-primary ml-2 col-3"
                                disabled={this.state.formSubmitting || this.state.formAlert || this.state.fileErr}
                            >
                                {this.state.formSubmitting ?
                                    <div className="spinner-border spinner-border-sm"></div> :
                                    <span>Upload</span>
                                }
                            </button>

                        </form>
                    }
                </Container>

                <div className="container-fluid">
                    {this.state.listAlert ? <Alert>{this.state.listAlert}</Alert> :
                        this.state.invoices.length === 0 ? null :
                            <Table>
                                <thead>
                                <tr>
                                    <th>Invoice</th>
                                    <th>Date</th>
                                    <th>Due date</th>
                                    <th>Invoice, $</th>
                                    <th>Total bills, $</th>
                                    <th>NovaPoshta</th>
                                    <th>Boxberry</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.invoices.map((v, i) => {
                                        const invoiceAmount = Number(v.invoice_amount_cents / 100).toLocaleString();
                                        const totalBillsAmount = Number(v.total_bills_cents / 100).toLocaleString();
                                        let npBillAmount;
                                        if (v.np_bill_cents > 0) {
                                            npBillAmount = Number(v.np_bill_cents / 100).toLocaleString();
                                        }
                                        let bxbBillAmount;
                                        if (v.bxb_bill_cents > 0) {
                                            bxbBillAmount = Number(v.bxb_bill_cents / 100).toLocaleString();
                                        }
                                        let withoutTrack;
                                        if (v.sum_of_charges_without_track_centicents > 0) {
                                            withoutTrack = Number(v.sum_of_charges_without_track_centicents / 10000).toLocaleString();
                                        }
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    {/*<a href={"/upsmi-invoices/" + v.invoice_number}>{v.invoice_number}</a>*/}
                                                    {v.invoice_number}
                                                </td>
                                                <td>{FormatDate(v.invoice_date)}</td>
                                                <td>{FormatDate(v.invoice_due_date)}</td>
                                                {withoutTrack>0? <td style={{color: 'red'}} title={withoutTrack + '$ - charges without track'}>{invoiceAmount}</td>:<td>{invoiceAmount}</td>}
                                                <td>{totalBillsAmount}</td>
                                                <td>
                                                    <div className="col">
                                                        <div className="row">
                                                            <a href={`https://import.veloxhub.us/api/v1/admin/upsmi-bills/${v.np_bill_number}?token=${localStorage.getItem('token')}`}>
                                                                {v.np_bill_number}
                                                            </a>
                                                        </div>
                                                        <div className="row">{npBillAmount}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="col">
                                                        <div className="row">
                                                            <a href={`https://import.veloxhub.us/api/v1/admin/upsmi-bills/${v.bxb_bill_number}?token=${localStorage.getItem('token')}`}>
                                                                {v.bxb_bill_number}
                                                            </a>
                                                        </div>
                                                        <div className="row">{bxbBillAmount}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </Table>
                    }

                    {this.state.invoices.length === 0 ? null :
                        <ul className="pagination justify-content-center">
                            <li className={this.state.currentPage === 1 ? "page-item disabled" : "page-item"}>
                                <a className="page-link" href="#" onClick={(e) => {
                                    e.preventDefault()
                                    this.getInvoices(this.state.currentPage - 1)
                                }}>
                                    Previous
                                </a>
                            </li>
                            <li className="page-item active"><span className="page-link">{this.state.currentPage}</span>
                            </li>

                            <li className={this.state.currentPage === this.state.pagesTotal ? "page-item disabled" : "page-item"}>
                                <a className="page-link" href="#" onClick={(e) => {
                                    e.preventDefault()
                                    this.getInvoices(this.state.currentPage + 1)
                                }}>
                                    Next
                                </a>
                            </li>
                        </ul>
                    }
                </div>


            </div>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (!this.state.file) {
            this.setState({fileErr: 'required'})
            return
        }

        if (this.state.file.size > 50000000) {
            this.setState({fileErr: 'file size must be less than 50Mb'})
            return
        }

        this.setState({formSubmitting: true});
        // "proxy": "http://sandbox-import.veloxhub.us",
        this.uploadFile(this.state.file)
    };

    uploadFile = (file) => {
        fetch('/api/v1/admin/upsmi-invoices', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${Storage.getToken()}`,
                'Content-Type': 'text/csv',
            },
            body: file,
        })
            .then(response => {
                switch (response.status) {
                    case 201:
                        response.json()
                            .then(data => {
                                this.setState((prevState) => {
                                    return {invoices: [data, ...prevState.invoices]}
                                })
                            })
                            .catch(err => {
                                this.setState({formAlert: JSON.stringify(err)});
                            })
                        return
                    case 401:
                        Logout();
                        return
                    case 409:
                        this.setState({formAlert: 'Invoice already exists'});
                        return
                    case 422:
                        response.json()
                            .then(data => {
                                const msg = 'Invalid CSV: ' + JSON.stringify(data['errors'])
                                this.setState({formAlert: msg})
                            })
                            .catch(err => {
                                const msg = 'Invalid CSV: ' + JSON.stringify(err)
                                this.setState({formAlert: msg})
                            })
                        return
                    case 500:
                        this.setState({formAlert: 'Internal server error, please contact admin'});
                        return
                    default:
                        this.setState({formAlert: 'Invalid status: ' + response.status});
                        return
                }
            })
            .catch(err => {
                this.setState({formAlert: JSON.stringify(err)});
            })
            .finally(_ => {
                this.setState({formSubmitting: false, filename: FILENAME});
            })
    }

    componentDidMount() {
        this.getInvoices(1);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentPage !== this.state.currentPage) {
            this.invoicesRef.current.scrollIntoView(true);
        }
    }

    getInvoices(page) {
        this.setState({listLoading: true})
        JwtClient.get(`/api/v1/admin/upsmi-invoices?page=${page}`)
            .then(response => {
                const data = response.data;
                this.setState({
                    invoices: data.invoices,
                    pagesTotal: data.total_pages,
                });
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    this.setState({listAlert: 'Error on fetching, status: ' + err.response.status});
                } else {
                    this.setState({listAlert: JSON.stringify(err)});
                }
            })
            .finally(() => {
                this.setState({listLoading: false, currentPage: page})
            })
    }
}
